import Link from '@components/common/Link/Link'
import Section from '@components/common/Section/Section'
import SublimeMedia from '@components/common/SublimeMedia/SublimeMedia'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import { findRichTextLink } from '@lib/findRichTextLink'
import cn, { clsx } from 'clsx'
import { FC, useRef } from 'react'
import { MediaPicker } from 'types/mediaPicker'
import { UmbracoLink } from 'types/umbracoLink'
import styles from './BookComponent.module.scss'
type BookComponentProps = {
  reversed?: boolean
  backgroundColor?: string
  textColor?: string
  bookTitle?: string
  descriptionImage?: MediaPicker
  richText?: string
  link?: UmbracoLink
  contentImage?: MediaPicker
}

const BookComponent: FC<BookComponentProps> = ({
  bookTitle,
  descriptionImage,
  richText,
  link,
  contentImage,
  backgroundColor,
  textColor,
  reversed,
}) => {
  const container = useRef(null)
  return (
    <Section
      style={{ backgroundColor: `#${backgroundColor}`, color: `#${textColor}` }}
      className={clsx(styles.container, { [styles.reversed]: reversed })}
      ref={container}
    >
      <div className={styles.descriptionBox}>
        <div className={styles.descriptionBoxInner}>
          <TrustedHtml
            className={cn(`headerOne`, styles.text)}
            html={bookTitle}
          />
          <Link
            link={link ? link : (findRichTextLink(richText) ?? null)}
            className={styles.descriptionImageContainer}
          >
            {descriptionImage && (
              <SublimeMedia
                mediaPicker={descriptionImage}
                className={styles.desktopImage}
                aspectRatio={'4 / 5'}
              />
            )}
            {contentImage && (
              <SublimeMedia
                mediaPicker={contentImage}
                className={styles.mobileImage}
              />
            )}
          </Link>
          <TrustedHtml className={styles.richText} html={richText} />
          {link && (
            <Link className={styles.ctaLink} link={{ url: link.url }}>
              {link.name}
            </Link>
          )}
        </div>
      </div>
      <Link
        link={link ? link : (findRichTextLink(richText) ?? null)}
        className={cn(styles.imageBox)}
      >
        {/* <div ref={imageRef} > */}
        {contentImage && (
          <SublimeMedia className={styles.image} mediaPicker={contentImage} />
        )}
        {/* </div> */}
      </Link>
    </Section>
  )
}

export default BookComponent
